






































































































































































































































































































































































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import IconButton from '@c/controls/IconButton.vue';
import DateTimePicker from '@c/controls/DateTimePicker.vue';
import Loading from '@c/controls/Loading.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import {httpClient} from '@/api/baseApi';
import oilReportModule from '@/store/modules/entities/oilReportModule';

@Component({
  components: {
    DateTimePicker,
    TableCheckBox,
    IconButton,
    CancelChangesDialog,
    Loading,
  },
})
export default class OilReportDetails extends Vue {
  loading = true;
  error = false;
  saving = false;
  valid = true;
  oId!: number;

  get apiStore() {
    oilReportModule.setOid(+this.$router.currentRoute.params.oid);
    return oilReportModule;
  }

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';
  nonNegativeNumberRule = (v: any) =>
    v >= 0 || v == null || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  oilData: any = {};

  report_types = [
    {value: 0, description: 'Отбор'},
    {value: 1, description: 'Замена'},
  ];

  hints: any = {};

  async onSave() {
    const err_container = this.$refs.err_text as any;
    this.valid = await (this.$refs.form as any).validate();
    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }
    if (err_container) err_container.innerText = 'Обрабатываю...';
    try {
      const ORM = this.apiStore;
      await ORM.save(this.oilData);
    } catch (err) {
      console.log(err);
      if (err_container) err_container.innerText = 'Ошибка обновления: ' + err;
      return;
    }
    if (err_container) err_container.innerText = '';
    router.push(`/oil/report/${this.oId}`);
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async created() {
    this.oId = +this.$router.currentRoute.params.oid;
    const ORM = this.apiStore;
    const rId = +this.$router.currentRoute.params.id;
    try {
      const {data} = await httpClient.get('/oil-nodes/references');
      this.hints = data;
      if (rId) {
        const {data} = await ORM.edit(rId);
        this.oilData = data;
      } else {
        const {data} = await ORM.create();
        this.oilData = data;
      }
    } catch {
      this.error = true;
    }
    this.loading = false;
  }

  back() {
    const cancelChangesDialog = this.$refs.cancelChangesDialog as any;
    // если были внесены изменения на форме
    if (this.changed) {
      cancelChangesDialog.open(`/oil/${this.oId}/admin`);
    } else router.push(`/oil/${this.oId}/admin`);
  }

  setSamplingDate(value: number) {
    this.oilData.sampling_ts = value;
    this.changed = true;
  }

  setReceptionDate(value: number) {
    this.oilData.reception_ts = value;
    this.changed = true;
  }

  setReportDate(value: number) {
    this.oilData.report_ts = value;
    this.changed = true;
  }
}
